export default __webpack_public_path__ + "static/media/ternary_operator.2d13e4d9.jpg";